import { Typography } from '@mui/material';
import { styled } from '@mui/material/styles';

export const Title = styled(Typography)(({ theme }) => ({
  [theme.breakpoints.down('md')]: {
    ...theme.typography.h2Redesign,
  },
}));
